import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Filters,
  title: 'Filters',
  category: ComponentCategory.General,
  droppable: false,
};
